
import { Component, Vue } from "vue-property-decorator";
import * as PageAction from "@/utils/PageActionUtils";
import * as queries from "@/graphql/queries";
import { API } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { GetAccountQuery, GetUserQuery } from "@/API";

@Component
export default class UserBaseForm extends Vue {
  name = "coverage-base-form";
  valid = false;
  PageAction = PageAction;

  id = "";
  userName = "";
  email = "";
  accountName = "";
  department = "";

  // 入力ルール
  userNameRules = [(v) => !!v, (v) => v && v.length <= 64];
  emailRules = [(v) => !!v, (v) => v && v.length <= 64];

  protected async setUser() {
    //CognitoUserの最新情報を取得する
    const attributes = this.$store.state.user.attributes;
    const user = (await API.graphql({
      query: queries.getUser,
      variables: { input: { id: attributes.sub } },
    })) as GraphQLResult<GetUserQuery>;

    const account = (await API.graphql({
      query: queries.getAccount,
      variables: { id: user.data?.getUser?.accountId },
    })) as GraphQLResult<GetAccountQuery>;
    this.userName = user.data?.getUser?.name || "";
    this.id = user.data?.getUser?.id || "";
    this.email = user.data?.getUser?.email || "";
    this.accountName = account.data?.getAccount?.company || "";
    this.department = user.data?.getUser?.department || "";
  }
}
